import {Fetch} from "helpers/fetchWrapper";

const authService = {
    _url: `${process.env.REACT_APP_BUSINESS_MANAGEMENT_URL}`,
    _otp_url: `${process.env.REACT_APP_USER_AUTH_URL}`,
    _otp_cookie: `${process.env.REACT_APP_FOODIE_TOKEN_COOKIE}`,

    async signUp(payload) {
        let res = await Fetch.post(`${this._url}/registration`, payload);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },

    async verifyOtp(payload) {
        let res = await Fetch.post(`${this._otp_url}/auth/verify-otp`, payload);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            // setCookie(this._otp_cookie, res.token);
            return res;
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },

    async resentOtp(email) {
        let res = await Fetch.post(`${this._otp_url}/auth/resend-otp`, email);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },

    async completeProfile(payload) {
        let res = await Fetch.upload(`${this._url}/complete-profile`, "POST", payload);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },

    async login({email = "", password = ""}) {
        let res = await Fetch.post(`${this._url}/login`, {
            email,
            password,
            websiteSource: process.env.REACT_APP_WEBSITE_SOURCE,
        });
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        
        const errorResponse = await res.json();
        
        if (errorResponse.success === false && errorResponse.user?.subscriptionStatus) {
            return errorResponse; // Return the full response for proper handling
        }
        
        const {message} = errorResponse;
        throw new Error(message ?? "Something went wrong");
    },

    async forgetPassword(payload) {
        let res = await Fetch.post(`${this._otp_url}/auth/forget-password`, payload);
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },

    async resetPassword(payload, token) {
        let res = await fetch(`${this._otp_url}/auth/reset-password`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        });
        if (res.status >= 200 && res.status < 300) {
            res = await res.json();
            return res;
        }
        const {message} = await res.json();
        throw new Error(message ?? "Something went wrong");
    },
};
export default authService;
